export default class Customer {
    public lastName: string = null!;
    public firstName: string = null!;
    public address1: string = null!;
    public address2: string = null!;
    public city: string = null!;
    public state: string = null!;
    public zip: string = null!;
    public homePhone: string = null!;
    public workPhone: string = null!;
    public cellPhone: string = null!;
    public emailAddress: string = null!;
    public vehicleLicense: string = null!;
    public vehicleState: string = null!;
    public recID: number = null!;
    public doNotAllowCheck: boolean = null!;
    public dateOfBirth: string = null!;
    public driversLicense: string = null!;
    public sentToDmv: boolean = null!;
    public middleName: string = null!;
    public businessName: string = null!;
    public citationCustomerLinked: boolean = null!;
    public lastUpdatedDate: string = null!;
    public doNotSendLetters: boolean = null!;
    public emailNotices: boolean = null!;
    public isBusiness: boolean = null!;
}
